module.exports = __webpack_public_path__ + "300ecba435b0e39ae3502d26b4b17b1f.png";